<template>
  <div class="page-container">
    <div class="table-wrapper">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="短信发送记录" name="log"></el-tab-pane>
        <el-tab-pane label="短信通道配置" name="channel"></el-tab-pane>
        <el-tab-pane label="短信模版配置" name="template"></el-tab-pane>
        <el-tab-pane label="验证码规则配置" name="rule"></el-tab-pane>
      </el-tabs>

      <!-- ==================== 短信发送记录 ==================== -->
      <div v-show="activeTab === 'log'">
        <el-form :inline="true" :model="lSearch" size="small" class="filter-bar" @submit.native.prevent>
          <el-form-item label="手机号码">
            <el-input v-model="lSearch.mobile" placeholder="手机号码" clearable style="width:140px;"></el-input>
          </el-form-item>
          <el-form-item label="短信通道">
            <el-select v-model="lSearch.provider" placeholder="全部" clearable style="width:130px;">
              <el-option v-for="(v, k) in PROVIDER" :key="k" :label="v" :value="Number(k)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短信类型">
            <el-select v-model="lSearch.scene" placeholder="全部" clearable style="width:150px;">
              <el-option v-for="(v, k) in SCENE" :key="k" :label="v" :value="k"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送状态">
            <el-select v-model="lSearch.sendStatus" placeholder="全部" clearable style="width:130px;">
              <el-option v-for="(v, k) in SEND_STATUS" :key="k" :label="v.label" :value="Number(k)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="校验状态">
            <el-select v-model="lSearch.verifyStatus" placeholder="全部" clearable style="width:130px;">
              <el-option v-for="(v, k) in VERIFY_STATUS" :key="k" :label="v.label" :value="Number(k)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送时间">
            <el-date-picker v-model="lDateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" style="width:260px;"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="lPageNum=1;fetchLogs()">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetLogSearch">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="table-header">
          <span class="table-title">短信发送记录</span>
          <div class="table-actions">
            <el-button v-auth="'cloud:smsLog:export'" size="small" icon="el-icon-download" @click="exportLogs">导出明细</el-button>
          </div>
        </div>
        <el-table :data="lTable" border v-loading="lLoading" style="width:100%;" size="small">
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="{row, $index}">{{ (lPageNum - 1) * lPageSize + $index + 1 }}</template>
          </el-table-column>
          <el-table-column label="短信通道" width="100">
            <template slot-scope="{row}">{{ providerName(row.provider) }}</template>
          </el-table-column>
          <el-table-column label="短信类型" width="120">
            <template slot-scope="{row}">{{ sceneLabel(row.scene) }}</template>
          </el-table-column>
          <el-table-column label="用户ID" width="110">
            <template slot-scope="{row}">{{ row.customerNo || '--' }}</template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="130"></el-table-column>
          <el-table-column label="验证码" width="90">
            <template slot-scope="{row}">{{ row.code || '--' }}</template>
          </el-table-column>
          <el-table-column prop="content" label="短信内容" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column label="发送状态" width="90" align="center">
            <template slot-scope="{row}">
              <el-tag :type="sendStatusTag(row.sendStatus)" size="mini">{{ sendStatusLabel(row.sendStatus) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="校验状态" width="90" align="center">
            <template slot-scope="{row}">
              <el-tag :type="verifyStatusTag(row.verifyStatus)" size="mini">{{ verifyStatusLabel(row.verifyStatus) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="errorMsg" label="报错原因" width="140" show-overflow-tooltip>
            <template slot-scope="{row}">{{ row.errorMsg || '--' }}</template>
          </el-table-column>
          <el-table-column label="发送时间" width="160">
            <template slot-scope="{row}">{{ fmtDateTime(row.sentAt) }}</template>
          </el-table-column>
          <el-table-column label="回执时间" width="160">
            <template slot-scope="{row}">{{ fmtDateTime(row.receiptAt) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="80" fixed="right" align="center">
            <template slot-scope="{row}">
              <el-button v-if="row.sendStatus === 3" v-auth="'cloud:smsLog:resend'" type="text" size="small" style="color:var(--brand-primary);" @click="resendLog(row)">重发</el-button>
              <span v-else style="color:#bfbfbf;font-size:12px;">--</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="(v)=>{lPageSize=v;lPageNum=1;fetchLogs()}" @current-change="(v)=>{lPageNum=v;fetchLogs()}"
          :current-page="lPageNum" :page-sizes="[15,30,50]" :page-size="lPageSize" layout="total,sizes,prev,pager,next,jumper" :total="lTotal"></el-pagination>
      </div>

      <!-- ==================== 短信通道配置 ==================== -->
      <div v-show="activeTab === 'channel'">
        <el-form :inline="true" :model="cSearch" size="small" class="filter-bar" @submit.native.prevent>
          <el-form-item label="短信通道名称">
            <el-input v-model="cSearch.name" placeholder="短信通道名称" clearable style="width:150px;"></el-input>
          </el-form-item>
          <el-form-item label="短信通道类型">
            <el-select v-model="cSearch.type" placeholder="全部" clearable style="width:130px;">
              <el-option v-for="(v, k) in PROVIDER" :key="k" :label="v" :value="Number(k)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="国家">
            <el-select v-model="cSearch.countryCode" multiple collapse-tags placeholder="全部(可多选)" clearable filterable allow-create default-first-option style="width:200px;">
              <el-option v-for="c in countryOptions" :key="c.value" :label="c.label" :value="c.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="cSearch.isDelete" placeholder="全部" clearable style="width:120px;">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="cPageNum=1;fetchChannels()">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetChannelSearch">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="table-header">
          <span class="table-title">短信通道列表</span>
          <div class="table-actions">
            <el-button v-auth="'cloud:smsChannel:save'" type="primary" size="small" icon="el-icon-plus" @click="openChannelAdd">+ 新增通道</el-button>
          </div>
        </div>
        <el-table :data="cTable" border v-loading="cLoading" style="width:100%;" size="small">
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="{row, $index}">{{ (cPageNum - 1) * cPageSize + $index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="短信通道名称" min-width="140"></el-table-column>
          <el-table-column label="短信通道类型" width="100">
            <template slot-scope="{row}"><span class="badge">{{ providerName(row.type) }}</span></template>
          </el-table-column>
          <el-table-column label="国家" min-width="150">
            <template slot-scope="{row}">
              <template v-if="row.countryCode">
                <el-tag v-for="c in splitCountries(row.countryCode)" :key="c" size="mini" style="margin:1px 4px 1px 0;">{{ countryLabel(c) }}</el-tag>
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column prop="signName" label="短信签名" width="130">
            <template slot-scope="{row}">{{ row.signName || '--' }}</template>
          </el-table-column>
          <el-table-column prop="createUser" label="创建人" width="90">
            <template slot-scope="{row}">{{ row.createUser || '--' }}</template>
          </el-table-column>
          <el-table-column prop="updateUser" label="最后更新人" width="100">
            <template slot-scope="{row}">{{ row.updateUser || '--' }}</template>
          </el-table-column>
          <el-table-column label="创建时间" width="160">
            <template slot-scope="{row}">{{ fmtDateTime(row.createDate) }}</template>
          </el-table-column>
          <el-table-column label="最后更新时间" width="160">
            <template slot-scope="{row}">{{ fmtDateTime(row.updateDate) }}</template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip>
            <template slot-scope="{row}">{{ row.remark || '--' }}</template>
          </el-table-column>
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="{row}">
              <el-switch v-auth="'cloud:smsChannel:status'" v-model="row.isDelete" :active-value="1" :inactive-value="2" active-color="var(--brand-primary)" @change="toggleChannel(row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right" align="center">
            <template slot-scope="{row}">
              <el-button v-auth="'cloud:smsChannel:edit'" type="text" size="small" style="color:var(--brand-primary);" @click="openChannelEdit(row)">编辑</el-button>
              <el-button v-auth="'cloud:smsChannel:delete'" type="text" size="small" style="color:#dc2626;" @click="deleteChannel(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="(v)=>{cPageSize=v;cPageNum=1;fetchChannels()}" @current-change="(v)=>{cPageNum=v;fetchChannels()}"
          :current-page="cPageNum" :page-sizes="[15,30,50]" :page-size="cPageSize" layout="total,sizes,prev,pager,next,jumper" :total="cTotal"></el-pagination>
      </div>

      <!-- ==================== 短信模版配置 ==================== -->
      <div v-show="activeTab === 'template'">
        <el-form :inline="true" :model="tSearch" size="small" class="filter-bar" @submit.native.prevent>
          <el-form-item label="模版编码">
            <el-input v-model="tSearch.code" placeholder="模版编码" clearable style="width:130px;"></el-input>
          </el-form-item>
          <el-form-item label="模版名称">
            <el-input v-model="tSearch.name" placeholder="模版名称" clearable style="width:130px;"></el-input>
          </el-form-item>
          <el-form-item label="短信类型">
            <el-select v-model="tSearch.scene" placeholder="全部" clearable style="width:150px;">
              <el-option v-for="(v, k) in SCENE" :key="k" :label="v" :value="k"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="语言">
            <el-select v-model="tSearch.lang" placeholder="全部" clearable style="width:130px;">
              <el-option v-for="(v, k) in LANG" :key="k" :label="v" :value="k"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短信通道">
            <el-select v-model="tSearch.provider" placeholder="全部" clearable style="width:130px;">
              <el-option v-for="(v, k) in PROVIDER" :key="k" :label="v" :value="Number(k)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="tSearch.isDelete" placeholder="全部" clearable style="width:120px;">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="tPageNum=1;fetchTemplates()">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetTemplateSearch">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="table-header">
          <span class="table-title">短信模版列表</span>
          <div class="table-actions">
            <el-button v-auth="'cloud:smsTemplate:save'" type="primary" size="small" icon="el-icon-plus" @click="openTemplateAdd">+ 新增模版</el-button>
            <el-button v-auth="'cloud:smsTemplate:import'" size="small" icon="el-icon-upload2" @click="importVisible = true">导入模版</el-button>
          </div>
        </div>
        <el-table :data="tTable" border v-loading="tLoading" style="width:100%;" size="small">
          <el-table-column prop="id" label="模版ID" width="80" align="center"></el-table-column>
          <el-table-column prop="code" label="模版编码" width="130"></el-table-column>
          <el-table-column prop="name" label="模版名称" min-width="130"></el-table-column>
          <el-table-column label="短信类型" width="120">
            <template slot-scope="{row}">{{ sceneLabel(row.scene) }}</template>
          </el-table-column>
          <el-table-column label="语言" width="90">
            <template slot-scope="{row}">{{ langLabel(row.lang) }}</template>
          </el-table-column>
          <el-table-column label="短信通道" width="90">
            <template slot-scope="{row}">{{ providerName(row.provider) }}</template>
          </el-table-column>
          <el-table-column label="短信签名" width="130">
            <template slot-scope="{row}">{{ row.channelSign || row.sign || '--' }}</template>
          </el-table-column>
          <el-table-column prop="content" label="模版内容" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createUser" label="创建人" width="90">
            <template slot-scope="{row}">{{ row.createUser || '--' }}</template>
          </el-table-column>
          <el-table-column prop="updateUser" label="最后更新人" width="100">
            <template slot-scope="{row}">{{ row.updateUser || '--' }}</template>
          </el-table-column>
          <el-table-column label="创建时间" width="150">
            <template slot-scope="{row}">{{ fmtDateTime(row.createDate) }}</template>
          </el-table-column>
          <el-table-column label="最后更新时间" width="150">
            <template slot-scope="{row}">{{ fmtDateTime(row.updateDate) }}</template>
          </el-table-column>
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="{row}">
              <el-switch v-auth="'cloud:smsTemplate:status'" v-model="row.isDelete" :active-value="1" :inactive-value="2" active-color="var(--brand-primary)" @change="toggleTemplate(row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="170" fixed="right" align="center">
            <template slot-scope="{row}">
              <el-button v-auth="'cloud:smsTemplate:view'" type="text" size="small" style="color:var(--brand-primary);" @click="viewTemplate(row)">查看</el-button>
              <el-button v-auth="'cloud:smsTemplate:edit'" type="text" size="small" style="color:var(--brand-primary);" @click="openTemplateEdit(row)">编辑</el-button>
              <el-button v-auth="'cloud:smsTemplate:testSend'" type="text" size="small" style="color:var(--brand-primary);" @click="openTest(row)">测试发送</el-button>
              <el-button v-auth="'cloud:smsTemplate:delete'" type="text" size="small" style="color:#dc2626;" @click="deleteTemplate(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="(v)=>{tPageSize=v;tPageNum=1;fetchTemplates()}" @current-change="(v)=>{tPageNum=v;fetchTemplates()}"
          :current-page="tPageNum" :page-sizes="[15,30,50]" :page-size="tPageSize" layout="total,sizes,prev,pager,next,jumper" :total="tTotal"></el-pagination>
      </div>

      <!-- ==================== 验证码规则配置 ==================== -->
      <div v-show="activeTab === 'rule'">
        <div class="rule-grid">
          <div v-for="rule in rList" :key="rule.id" class="rule-card">
            <div class="rule-head">
              <div class="rule-icon">{{ ruleIcon(rule.verifyType) }}</div>
              <div>
                <div class="rule-title">{{ ruleTypeLabel(rule.verifyType) }}</div>
                <div class="rule-code">{{ rule.verifyType }}</div>
              </div>
              <div class="rule-status">
                <el-switch v-auth="'cloud:smsRule:save'" v-model="rForm[rule.id].isDelete" :active-value="1" :inactive-value="2" active-color="var(--brand-primary)" @change="saveRuleStatus(rule)"></el-switch>
              </div>
            </div>
            <div class="rule-body">
              <div class="rule-item">
                <span class="rule-label">发送间隔(秒)</span>
                <el-input-number v-model="rForm[rule.id].sendInterval" :min="1" :controls="false" size="small" style="width:120px;"></el-input-number>
              </div>
              <div class="rule-item">
                <span class="rule-label">每日上限(条)</span>
                <el-input-number v-model="rForm[rule.id].dailyLimit" :min="1" :controls="false" size="small" style="width:120px;"></el-input-number>
              </div>
              <div class="rule-item">
                <span class="rule-label">每日上限统计口径</span>
                <el-select v-model="rForm[rule.id].dailyResetMode" size="small" style="width:150px;">
                  <el-option label="自然日0点重置" :value="1"></el-option>
                  <el-option label="滚动24小时" :value="2"></el-option>
                </el-select>
              </div>
              <div class="rule-item">
                <span class="rule-label">验证码位数</span>
                <el-input-number v-model="rForm[rule.id].codeLength" :min="1" :controls="false" size="small" style="width:120px;"></el-input-number>
              </div>
              <div class="rule-item">
                <span class="rule-label">验证码有效期(分钟)</span>
                <el-input-number v-model="rForm[rule.id].expireMinutes" :min="1" :controls="false" size="small" style="width:120px;"></el-input-number>
              </div>
              <div class="rule-item">
                <span class="rule-label">校验失败阈值(次)</span>
                <el-input-number v-model="rForm[rule.id].failLimit" :min="1" :controls="false" size="small" style="width:120px;"></el-input-number>
              </div>
              <div class="rule-item">
                <span class="rule-label">开启图形验证码</span>
                <el-select v-model="rForm[rule.id].captchaEnabled" size="small" style="width:120px;">
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="2"></el-option>
                </el-select>
              </div>
            </div>
            <div class="rule-foot">
              <div class="rule-meta">最后修改：{{ rule.updateUser || '--' }} {{ fmtDateTime(rule.updateDate) }}</div>
              <div class="rule-btns">
                <el-button size="small" @click="resetRule(rule)">取消</el-button>
                <el-button v-auth="'cloud:smsRule:save'" size="small" type="primary" @click="saveRule(rule)">保存</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-bar">
          <el-form :inline="true" :model="rLogSearch" size="small" @submit.native.prevent>
            <el-form-item label="短信类型">
              <el-select v-model="rLogSearch.verifyType" placeholder="全部" clearable style="width:150px;">
                <el-option v-for="(v, k) in RULE_SCENE" :key="k" :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作人">
              <el-input v-model="rLogSearch.operator" placeholder="操作人" clearable style="width:150px;"></el-input>
            </el-form-item>
            <el-form-item label="操作时间">
              <el-date-picker v-model="rLogDateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" style="width:260px;"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="rLogPageNum=1;fetchRuleLogs()">查询</el-button>
              <el-button icon="el-icon-refresh" @click="resetRuleLogSearch">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-header">
          <span class="table-title">规则变更历史</span>
        </div>
        <el-table :data="rLogTable" border v-loading="rLogLoading" style="width:100%;" size="small">
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="{row, $index}">{{ (rLogPageNum - 1) * rLogPageSize + $index + 1 }}</template>
          </el-table-column>
          <el-table-column label="短信类型" width="140">
            <template slot-scope="{row}">{{ ruleTypeLabel(row.verifyType) }}</template>
          </el-table-column>
          <el-table-column prop="fieldName" label="修改字段" width="140"></el-table-column>
          <el-table-column prop="oldValue" label="修改前" width="120">
            <template slot-scope="{row}">{{ row.oldValue || '--' }}</template>
          </el-table-column>
          <el-table-column prop="newValue" label="修改后" width="120">
            <template slot-scope="{row}">{{ row.newValue || '--' }}</template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" width="110">
            <template slot-scope="{row}">{{ row.operator || '--' }}</template>
          </el-table-column>
          <el-table-column label="操作时间" width="160">
            <template slot-scope="{row}">{{ fmtDateTime(row.createDate) }}</template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="(v)=>{rLogPageSize=v;rLogPageNum=1;fetchRuleLogs()}" @current-change="(v)=>{rLogPageNum=v;fetchRuleLogs()}"
          :current-page="rLogPageNum" :page-sizes="[15,30,50]" :page-size="rLogPageSize" layout="total,sizes,prev,pager,next,jumper" :total="rLogTotal"></el-pagination>
      </div>
    </div>

    <!-- 通道新增/编辑弹窗 -->
    <el-dialog :visible.sync="channelVisible" width="720px" :close-on-click-modal="false" :title="(channelForm.id ? '编辑' : '新增') + '短信通道'">
      <el-form :model="channelForm" label-width="130px" size="small" :rules="channelRules" ref="channelForm">
        <el-form-item label="短信通道名称" prop="name">
          <el-input v-model="channelForm.name" maxlength="50" placeholder="如：阿里云"></el-input>
        </el-form-item>
        <el-form-item label="短信通道类型" prop="type">
          <el-select v-model="channelForm.type" style="width:100%;" placeholder="请选择" @change="channelTypeChange">
            <el-option v-for="(v, k) in PROVIDER" :key="k" :label="v" :value="Number(k)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国家" prop="countryCode">
          <el-select v-model="channelForm.countryCode" multiple collapse-tags filterable allow-create default-first-option style="width:100%;" placeholder="请选择国家(可多选, 一条通道可服务多个国家)">
            <el-option v-for="c in countryOptions" :key="c.value" :label="c.label" :value="c.value"></el-option>
          </el-select>
        </el-form-item>
        <div class="form-hint" style="margin:-10px 0 12px 130px;">一条通道可绑定多个国家; 不选具体国家时可填 DEFAULT 作为兜底通道。同一国家仅允许一个启用中的通道。</div>
        <el-form-item label="短信签名" prop="signName">
          <el-input v-model="channelForm.signName" maxlength="50" placeholder="请输入短信签名"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="channelForm.remark" maxlength="200" placeholder="补充说明"></el-input>
        </el-form-item>
        <div class="form-section-title">接口配置（按通道类型区分）</div>
        <div class="form-grid">
          <el-form-item v-for="f in channelDefs" :key="f.key" :label="f.label" :required="(isAdd || !f.secret) && !f.optional">
            <el-input v-model="channelConfig[f.key]" :type="f.secret ? 'password' : 'text'" :show-password="f.secret" :placeholder="(f.secret && !isAdd) ? '留空表示不修改' : (f.def || '请输入')"></el-input>
          </el-form-item>
        </div>
        <div class="form-hint">密钥类配置在列表与详情中一律脱敏展示；编辑时留空将保留原值。</div>
      </el-form>
      <div slot="footer">
        <el-button @click="channelVisible=false">取消</el-button>
        <el-button type="primary" @click="submitChannel">{{ channelForm.id ? '保存' : '确定新增' }}</el-button>
      </div>
    </el-dialog>

    <!-- 模版新增/编辑弹窗 -->
    <el-dialog :visible.sync="templateVisible" width="720px" :close-on-click-modal="false" :title="(templateForm.id ? '编辑' : '新增') + '短信模版'">
      <el-form :model="templateForm" label-width="120px" size="small" :rules="templateRules" ref="templateForm">
        <el-form-item label="模版编码" prop="code">
          <el-input v-model="templateForm.code" :disabled="!!templateForm.id" placeholder="如 REGISTER_ZH_CN"></el-input>
        </el-form-item>
        <div class="form-grid">
          <el-form-item label="短信类型" prop="scene">
            <el-select v-model="templateForm.scene" style="width:100%;">
              <el-option v-for="(v, k) in SCENE" :key="k" :label="v" :value="k"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="语言" prop="lang">
            <el-select v-model="templateForm.lang" style="width:100%;">
              <el-option v-for="(v, k) in LANG" :key="k" :label="v" :value="k"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短信通道" prop="channelId">
            <el-select v-model="templateForm.channelId" filterable style="width:100%;" placeholder="请选择短信通道">
              <el-option v-for="ch in channelOptions" :key="ch.id" :label="ch.name + (ch.countryCode ? ' (' + countryText(ch.countryCode) + ')' : '')" :value="ch.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模版名称" prop="name">
            <el-input v-model="templateForm.name" maxlength="50" placeholder="请输入模版名称"></el-input>
          </el-form-item>
          <el-form-item label="通道模版ID" prop="chnTplId">
            <el-input v-model="templateForm.chnTplId" placeholder="第三方通道模版ID"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="模版内容" prop="content">
          <el-input v-model="templateForm.content" type="textarea" :rows="3" placeholder="选填；填写时需包含占位符 ${code}"></el-input>
        </el-form-item>
        <el-form-item label="变量说明">
          <el-input v-model="templateForm.varDesc" placeholder="如：code=验证码"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="templateForm.remark" maxlength="200" placeholder="补充说明"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="templateVisible=false">取消</el-button>
        <el-button type="primary" @click="submitTemplate">{{ templateForm.id ? '保存' : '确定新增' }}</el-button>
      </div>
    </el-dialog>

    <!-- 模版详情弹窗 -->
    <el-dialog :visible.sync="templateDetailVisible" width="640px" :close-on-click-modal="false" title="短信模版详情">
      <div v-if="templateDetail" class="detail-body">
        <div class="detail-grid">
          <div><span class="detail-label">模版ID：</span>{{ templateDetail.id }}</div>
          <div><span class="detail-label">模版编码：</span>{{ templateDetail.code }}</div>
          <div><span class="detail-label">模版名称：</span>{{ templateDetail.name }}</div>
          <div><span class="detail-label">短信类型：</span>{{ sceneLabel(templateDetail.scene) }}</div>
          <div><span class="detail-label">语言：</span>{{ langLabel(templateDetail.lang) }}</div>
          <div><span class="detail-label">短信通道：</span>{{ providerName(templateDetail.provider) }}</div>
          <div><span class="detail-label">短信签名：</span>{{ templateDetail.sign || '--' }}</div>
          <div><span class="detail-label">通道模版ID：</span>{{ templateDetail.chnTplId || '--' }}</div>
          <div><span class="detail-label">状态：</span>{{ templateDetail.isDelete === 1 ? '启用' : '禁用' }}</div>
          <div><span class="detail-label">变量说明：</span>{{ templateDetail.varDesc || '--' }}</div>
          <div><span class="detail-label">创建人：</span>{{ templateDetail.createUser || '--' }}</div>
          <div><span class="detail-label">更新时间：</span>{{ fmtDateTime(templateDetail.updateDate) }}</div>
        </div>
        <div class="detail-section-title">模版内容</div>
        <div class="detail-content">{{ templateDetail.content || '--' }}</div>
      </div>
      <div slot="footer">
        <el-button @click="templateDetailVisible=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 测试发送弹窗 -->
    <el-dialog :visible.sync="testVisible" width="460px" :close-on-click-modal="false" title="测试发送短信">
      <div class="test-tpl">模版：{{ testTemplate.code }}（{{ testTemplate.name }}）</div>
      <el-form :model="testForm" label-width="90px" size="small">
        <el-form-item label="测试手机号" required>
          <el-input v-model="testForm.mobile" placeholder="请输入接收测试短信的手机号"></el-input>
        </el-form-item>
      </el-form>
      <div class="form-hint">发送内容预览：{{ (testTemplate.content || '').substring(0, 60) }}</div>
      <div slot="footer">
        <el-button @click="testVisible=false">取消</el-button>
        <el-button type="primary" @click="submitTest">发送测试短信</el-button>
      </div>
    </el-dialog>

    <!-- 导入模版弹窗 -->
    <el-dialog :visible.sync="importVisible" width="640px" :close-on-click-modal="false" title="导入短信模版">
      <div class="form-hint" style="margin-bottom:8px;">每行一条，字段用半角逗号分隔；顺序：模版编码,模版名称,短信类型,语言,短信通道,短信签名,模版内容</div>
      <el-input v-model="importText" type="textarea" :rows="9" placeholder="REGISTER_ZH_CN,注册验证码(中文),REGISTER,zh_CN,1,【企业名称】,您的注册验证码为：${code}"></el-input>
      <div slot="footer">
        <el-button @click="importVisible=false">取消</el-button>
        <el-button type="primary" @click="submitImport">确认导入</el-button>
      </div>
    </el-dialog>

    <!-- 资金密码规则放宽确认弹窗 -->
    <el-dialog :visible.sync="ruleConfirmVisible" width="560px" :close-on-click-modal="false" title="资金密码规则放宽确认">
      <div class="confirm-warn">
        <i class="el-icon-warning" style="color:#e6a23c;font-size:16px;margin-right:6px;"></i>
        <span><b>高风险操作二次确认</b>：资金密码验证码规则被<b>放宽</b>，可能降低资金操作安全级别，请填写变更原因：</span>
      </div>
      <div class="confirm-changes">
        <div v-for="(c, i) in ruleConfirmChanges" :key="i">· {{ c.label }}：{{ c.old }} → {{ c.val }}</div>
      </div>
      <el-input v-model="ruleConfirmText" type="textarea" :rows="2" placeholder="请填写变更原因"></el-input>
      <div slot="footer">
        <el-button @click="ruleConfirmVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmRuleSave">确认保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { smsChannelList, smsChannelDetail, smsChannelAddOrUpdate, smsChannelStatus, smsChannelDeleteBatchIds,
  smsTemplateList, smsTemplateDetail, smsTemplateAddOrUpdate, smsTemplateStatus, smsTemplateDeleteBatchIds,
  smsTemplateBatchImport, smsTemplateTestSend,
  smsLogList, smsLogResend,
  smsRuleList, smsRuleAddOrUpdate, smsRuleLogList } from '@/api/sms'
import { countryList } from '@/api/regConfig'

const PROVIDER = { 1: '阿里云', 2: '腾讯云', 3: '麦讯通', 4: 'onesnok' }
const SCENE = { REGISTER: '注册验证码', LOGIN: '登录验证码', RESET_PWD: '重置密码验证码', FINANCE_PWD: '资金密码验证码', BIND_WALLET: '绑定钱包验证码', BIND_CONTACT: '绑定联系方式验证码', BACKEND_RESET_PWD: '后端重置密码' }
const RULE_SCENE = { REGISTER: '注册验证码', LOGIN: '登录验证码', RESET_PWD: '重置密码验证码', FINANCE_PWD: '资金密码验证码', BIND_WALLET: '绑定钱包验证码', BIND_CONTACT: '绑定联系方式验证码', BACKEND_RESET_PWD: '后端重置密码' }
const LANG = { zh_CN: '简体中文', zh_TW: '繁体中文', en_US: 'English' }
const SEND_STATUS = { 1: { label: '发送中', tag: 'warning' }, 2: { label: '发送成功', tag: 'success' }, 3: { label: '发送失败', tag: 'danger' } }
const VERIFY_STATUS = { 1: { label: '未使用', tag: 'info' }, 2: { label: '已使用', tag: 'success' }, 3: { label: '已过期', tag: 'danger' } }
const CHANNEL_TYPE_DEF = {
  1: [
    { key: 'version', label: 'API版本', secret: false, def: '2017-05-25' },
    { key: 'accessKeyId', label: 'AccessKey ID', secret: false },
    { key: 'accessKeySecret', label: 'AccessKey Secret', secret: true },
    { key: 'interfaceDomain', label: '短信接口域名', secret: false, def: 'dysmsapi.aliyuncs.com' }
  ],
  2: [
    { key: 'secretId', label: 'SecretId', secret: false },
    { key: 'secretKey', label: 'SecretKey', secret: true },
    { key: 'appId', label: 'AppId', secret: false }
  ],
  3: [
    { key: 'account', label: '账号', secret: false },
    { key: 'password', label: '密码', secret: true }
  ],
  4: [
    { key: 'spId', label: '产品SP ID', secret: false },
    { key: 'password', label: '产品密码', secret: true },
    { key: 'aesKey', label: 'AES密钥(16位)', secret: true, optional: true },
    { key: 'authMode', label: '鉴权方式(signature/password)', secret: false, def: 'signature' },
    { key: 'ext', label: '扩展号', secret: false, optional: true },
    { key: 'url', label: '接口地址', secret: false, def: 'http://www.onesnok.net:9511' }
  ]
}
const RULE_LOOSEN = { sendInterval: 'down', dailyLimit: 'up', codeLength: 'down', expireMinutes: 'up', failLimit: 'up' }
const RULE_LABEL = {
  sendInterval: '发送间隔(秒)', dailyLimit: '每日上限(条)', codeLength: '验证码位数',
  expireMinutes: '验证码有效期(分钟)', failLimit: '校验失败阈值(次)'
}

export default {
  name: 'CloudSmsList',
  data() {
    return {
      activeTab: 'log',
      PROVIDER, SCENE, RULE_SCENE, LANG, SEND_STATUS, VERIFY_STATUS,
      countryOptions: [],
      countryNameMap: {},

      // 通道
      cSearch: { name: '', type: null, countryCode: [], isDelete: null },
      cTable: [], cLoading: false, cTotal: 0, cPageNum: 1, cPageSize: 15,
      channelVisible: false, channelForm: {}, channelConfig: {}, channelDefs: [],
      channelRules: {
        name: [{ required: true, message: '请输入短信通道名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择短信通道类型', trigger: 'change' }],
        countryCode: [{ required: true, type: 'array', message: '请选择国家', trigger: 'change' }],
        signName: [{ required: true, message: '请输入短信签名', trigger: 'blur' }]
      },
      channelOptions: [],

      // 模版
      tSearch: { code: '', name: '', scene: '', lang: '', provider: null, isDelete: null },
      tTable: [], tLoading: false, tTotal: 0, tPageNum: 1, tPageSize: 15,
      templateVisible: false, templateForm: {}, templateDetailVisible: false, templateDetail: null,
      testVisible: false, testTemplate: {}, testForm: { mobile: '' },
      importVisible: false, importText: '',

      // 日志
      lSearch: { mobile: '', provider: null, scene: '', sendStatus: null, verifyStatus: null, startDate: '', endDate: '' },
      lDateRange: null, lTable: [], lLoading: false, lTotal: 0, lPageNum: 1, lPageSize: 15,

      // 规则
      rList: [], rForm: {},
      rLogSearch: { verifyType: '', operator: '', startDate: '', endDate: '' },
      rLogDateRange: null, rLogTable: [], rLogLoading: false, rLogTotal: 0, rLogPageNum: 1, rLogPageSize: 15,
      ruleConfirmVisible: false, ruleConfirmText: '', ruleConfirmChanges: [], rulePending: null
    }
  },
  computed: {
    isAdd() { return !this.channelForm.id },
    selectedChannel() { return this.channelOptions.find(c => c.id === this.templateForm.channelId) },
    templateRules() {
      return {
        code: [{ required: true, message: '请输入模版编码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入模版名称', trigger: 'blur' }],
        scene: [{ required: true, message: '请选择短信类型', trigger: 'change' }],
        lang: [{ required: true, message: '请选择语言', trigger: 'change' }],
        channelId: [{ required: true, message: '请选择短信通道', trigger: 'change' }]
      }
    }
  },
  created() {
    this.fetchCountries()
    this.fetchChannelOptions()
    this.fetchLogs()
  },
  watch: {
    activeTab(v) {
      if (v === 'channel') this.fetchChannels()
      else if (v === 'template') this.fetchTemplates()
      else if (v === 'rule') { this.fetchRules(); this.fetchRuleLogs() }
      else if (v === 'log') this.fetchLogs()
    }
  },
  methods: {
    getOperator() {
      try {
        const label = this.$route.query.label
        const user = JSON.parse(localStorage.getItem(label + '_sys_userInfo'))
        return (user && user.displayName) || 'admin'
      } catch (e) { return 'admin' }
    },
    fetchCountries() {
      countryList({ pageNum: 1, pageSize: 500 }).then(res => {
        if (res.code === 0) {
          // 通道的 country_code 存 ISO 码(与 t_reg_country_config/GeoLite2/C端 同源), 中文名仅作展示
          const codes = (res.result.list || []).filter(c => c.countryCode)
          // DEFAULT 为兜底通道字面量, 非真实国家, 单独补一个选项便于配置
          this.countryOptions = [{ value: 'DEFAULT', label: '兜底 (DEFAULT)' }].concat(
            codes.map(c => ({ value: c.countryCode, label: `${c.countryCname || c.countryName || c.countryCode} (${c.countryCode})` })))
          // 列表与模版下拉按国家代码回显中文名
          const nameMap = { DEFAULT: '兜底' }
          codes.forEach(c => { nameMap[c.countryCode] = c.countryCname || c.countryName || c.countryCode })
          this.countryNameMap = nameMap
        }
      }).catch(() => {})
    },

    // ========== 通道 ==========
    // 后端 country_code 为逗号分隔多值, 此处与多选数组互转
    splitCountries(text) {
      return String(text || '').split(',').map(s => s.trim()).filter(Boolean)
    },
    // 国家代码 → 中文名(仅展示用, 未知代码原样输出)
    countryLabel(code) {
      const c = String(code || '').trim()
      return c ? (this.countryNameMap[c] || c) : c
    },
    // "SG,UK" → "新加坡/英国"
    countryText(text) {
      return this.splitCountries(text).map(c => this.countryLabel(c)).join('/')
    },
    fetchChannels() {
      this.cLoading = true
      const data = { pageNum: this.cPageNum, pageSize: this.cPageSize }
      Object.keys(this.cSearch).forEach(k => {
        let v = this.cSearch[k]
        if (Array.isArray(v)) { if (!v.length) return; v = v.join(',') }
        if (v !== '' && v !== null && v !== undefined) data[k] = v
      })
      smsChannelList(data).then(res => {
        if (res.code === 0) { this.cTable = res.result.list || []; this.cTotal = res.result.total || 0 }
        else this.$message.error(res.message || '查询失败')
      }).finally(() => { this.cLoading = false })
    },
    resetChannelSearch() {
      this.cSearch = { name: '', type: null, countryCode: [], isDelete: null }
      this.cPageNum = 1; this.fetchChannels()
    },
    channelTypeChange() {
      this.channelDefs = CHANNEL_TYPE_DEF[this.channelForm.type] || []
      const cfg = {}
      this.channelDefs.forEach(f => { cfg[f.key] = f.def || '' })
      this.channelConfig = cfg
    },
    openChannelAdd() {
      this.channelForm = { id: null, name: '', type: 1, countryCode: [], signName: '', remark: '' }
      this.channelTypeChange()
      this.channelVisible = true
    },
    openChannelEdit(row) {
      // 编辑时调用详情接口加载真实密钥（列表接口脱敏，不会带出密钥）
      smsChannelDetail(row.id).then(res => {
        if (res.code !== 0) { this.$message.error(res.message || '查询失败'); return }
        const data = res.result || row
        this.channelForm = {
          id: data.id, name: data.name, type: data.type,
          countryCode: this.splitCountries(data.countryCode), signName: data.signName || '', remark: data.remark || ''
        }
        this.channelDefs = CHANNEL_TYPE_DEF[data.type] || []
        const cfg = {}
        let parsed = {}
        try { parsed = data.configJson ? JSON.parse(data.configJson) : {} } catch (e) { parsed = {} }
        this.channelDefs.forEach(f => { cfg[f.key] = parsed[f.key] != null && parsed[f.key] !== '' ? parsed[f.key] : (f.def || '') })
        this.channelConfig = cfg
        this.channelVisible = true
      })
    },
    submitChannel() {
      this.$refs.channelForm.validate(valid => {
        if (!valid) return
        for (const f of this.channelDefs) {
          const val = (this.channelConfig[f.key] || '').trim()
          if (this.isAdd && !f.optional && !val) { this.$message.error('请填写接口配置：' + f.label); return }
        }
        const configJson = JSON.stringify(this.channelConfig)
        const dto = {
          id: this.channelForm.id, name: this.channelForm.name, type: this.channelForm.type,
          countryCode: (this.channelForm.countryCode || []).join(','), signName: this.channelForm.signName,
          configJson, remark: this.channelForm.remark, operator: this.getOperator()
        }
        smsChannelAddOrUpdate(dto).then(res => {
          if (res.code === 0) {
            this.$message.success(this.channelForm.id ? '保存成功' : '新增成功')
            this.channelVisible = false
            this.fetchChannels()
          } else this.$message.error(res.message || '操作失败')
        })
      })
    },
    toggleChannel(row) {
      smsChannelStatus(row.id, row.isDelete).then(res => {
        if (res.code === 0) {
          this.$message.success(row.isDelete === 1 ? '已启用' : '已禁用')
        } else {
          this.$message.error(res.message || '操作失败')
        }
        this.fetchChannels()
      })
    },
    deleteChannel(row) {
      this.$confirm('确认删除短信通道「' + row.name + '」吗？', '删除确认', { type: 'warning' }).then(() => {
        smsChannelDeleteBatchIds(row.id).then(res => {
          if (res.code === 0) { this.$message.success('删除成功'); this.fetchChannels() }
          else this.$message.error(res.message || '操作失败')
        })
      }).catch(() => {})
    },

    // ========== 模版 ==========
    fetchChannelOptions() {
      smsChannelList({ pageNum: 1, pageSize: 500 }).then(res => {
        if (res.code === 0) this.channelOptions = res.result.list || []
      }).catch(() => {})
    },
    fetchTemplates() {
      this.tLoading = true
      const data = { pageNum: this.tPageNum, pageSize: this.tPageSize }
      Object.keys(this.tSearch).forEach(k => {
        if (this.tSearch[k] !== '' && this.tSearch[k] !== null && this.tSearch[k] !== undefined) data[k] = this.tSearch[k]
      })
      smsTemplateList(data).then(res => {
        if (res.code === 0) { this.tTable = res.result.list || []; this.tTotal = res.result.total || 0 }
        else this.$message.error(res.message || '查询失败')
      }).finally(() => { this.tLoading = false })
    },
    resetTemplateSearch() {
      this.tSearch = { code: '', name: '', scene: '', lang: '', provider: null, isDelete: null }
      this.tPageNum = 1; this.fetchTemplates()
    },
    openTemplateAdd() {
      this.templateForm = {
        id: null, code: '', name: '', scene: 'REGISTER', lang: 'zh_CN', channelId: '',
        chnTplId: '', content: '', varDesc: '', remark: '', isDelete: 1
      }
      this.templateVisible = true
    },
    openTemplateEdit(row) {
      this.templateForm = {
        id: row.id, code: row.code, name: row.name, scene: row.scene, lang: row.lang || 'zh_CN',
        channelId: row.channelId != null ? row.channelId : '', chnTplId: row.chnTplId || '', content: row.content,
        varDesc: row.varDesc || '', remark: row.remark || '', isDelete: row.isDelete
      }
      this.templateVisible = true
    },
    submitTemplate() {
      this.$refs.templateForm.validate(valid => {
        if (!valid) return
        const ch = this.channelOptions.find(c => c.id === this.templateForm.channelId)
        const content = (this.templateForm.content || '').trim()
        if (content && content.indexOf('${code}') === -1) {
          this.$message.error('验证码类模版的内容必须包含占位符 ${code}')
          return
        }
        const dto = Object.assign({ operator: this.getOperator() }, this.templateForm, { provider: ch ? ch.type : null })
        smsTemplateAddOrUpdate(dto).then(res => {
          if (res.code === 0) {
            this.$message.success(this.templateForm.id ? '保存成功' : '新增成功')
            this.templateVisible = false
            this.fetchTemplates()
          } else this.$message.error(res.message || '操作失败')
        })
      })
    },
    toggleTemplate(row) {
      smsTemplateStatus(row.id, row.isDelete).then(res => {
        if (res.code === 0) {
          this.$message.success(row.isDelete === 1 ? '已启用' : '已禁用')
          this.fetchTemplates()
        } else this.$message.error(res.message || '操作失败')
      })
    },
    deleteTemplate(row) {
      this.$confirm('确认删除短信模版「' + row.code + '」吗？', '删除确认', { type: 'warning' }).then(() => {
        smsTemplateDeleteBatchIds(row.id).then(res => {
          if (res.code === 0) { this.$message.success('删除成功'); this.fetchTemplates() }
          else this.$message.error(res.message || '操作失败')
        })
      }).catch(() => {})
    },
    viewTemplate(row) {
      smsTemplateDetail(row.id).then(res => {
        if (res.code === 0) { this.templateDetail = res.result; this.templateDetailVisible = true }
        else this.$message.error(res.message || '查询失败')
      })
    },
    openTest(row) {
      this.testTemplate = row
      this.testForm = { mobile: '' }
      this.testVisible = true
    },
    submitTest() {
      if (!this.testForm.mobile) { this.$message.error('请输入测试手机号'); return }
      smsTemplateTestSend(this.testTemplate.id, this.testForm.mobile, this.getOperator()).then(res => {
        if (res.code === 0) {
          this.$message.success(res.result || '测试短信已发送')
          this.testVisible = false
        } else this.$message.error(res.message || '操作失败')
      })
    },
    submitImport() {
      const txt = (this.importText || '').trim()
      if (!txt) { this.$message.error('请粘贴要导入的模版数据'); return }
      const normScene = s => {
        for (const k in SCENE) { if (k === s || SCENE[k] === s) return k }
        return 'REGISTER'
      }
      const normLang = s => ({ 'zh-CN': 'zh_CN', 'zh-TW': 'zh_TW', 'en-US': 'en_US' }[s] || s || 'zh_CN')
      const normProvider = s => {
        if (/^\d+$/.test(s)) return Number(s)
        for (const k in PROVIDER) { if (PROVIDER[k] === s) return Number(k) }
        return 1
      }
      const list = []
      txt.split(/\r?\n/).map(s => s.trim()).filter(Boolean).forEach(line => {
        const p = line.split(',').map(s => s.trim())
        if (!p[0] || !p[1]) return
        list.push({
          code: p[0], name: p[1], scene: normScene(p[2]), lang: normLang(p[3]),
          provider: normProvider(p[4]), sign: p[5] || '', content: p[6] || '',
          operator: this.getOperator()
        })
      })
      if (!list.length) { this.$message.error('没有可导入的数据'); return }
      smsTemplateBatchImport(list).then(res => {
        if (res.code === 0) {
          this.$message.success(res.result || '导入完成')
          this.importVisible = false
          this.importText = ''
          this.fetchTemplates()
        } else this.$message.error(res.message || '导入失败')
      })
    },

    // ========== 日志 ==========
    fetchLogs() {
      this.lLoading = true
      const data = { pageNum: this.lPageNum, pageSize: this.lPageSize }
      Object.keys(this.lSearch).forEach(k => {
        if (this.lSearch[k] !== '' && this.lSearch[k] !== null && this.lSearch[k] !== undefined) data[k] = this.lSearch[k]
      })
      if (this.lDateRange && this.lDateRange.length === 2) {
        data.startDate = this.lDateRange[0]
        data.endDate = this.lDateRange[1]
      }
      smsLogList(data).then(res => {
        if (res.code === 0) { this.lTable = res.result.list || []; this.lTotal = res.result.total || 0 }
        else this.$message.error(res.message || '查询失败')
      }).finally(() => { this.lLoading = false })
    },
    resetLogSearch() {
      this.lSearch = { mobile: '', provider: null, scene: '', sendStatus: null, verifyStatus: null, startDate: '', endDate: '' }
      this.lDateRange = null
      this.lPageNum = 1; this.fetchLogs()
    },
    resendLog(row) {
      this.$confirm('确定对记录「' + row.reqId + '」重新发送一条短信吗？将生成新的流水号。', '重发确认', { type: 'warning' }).then(() => {
        smsLogResend(row.id, this.getOperator()).then(res => {
          if (res.code === 0) { this.$message.success(res.result || '已重新发送'); this.fetchLogs() }
          else this.$message.error(res.message || '操作失败')
        })
      }).catch(() => {})
    },
    exportLogs() {
      const data = { pageNum: 1, pageSize: 100000 }
      Object.keys(this.lSearch).forEach(k => {
        if (this.lSearch[k] !== '' && this.lSearch[k] !== null && this.lSearch[k] !== undefined) data[k] = this.lSearch[k]
      })
      if (this.lDateRange && this.lDateRange.length === 2) { data.startDate = this.lDateRange[0]; data.endDate = this.lDateRange[1] }
      smsLogList(data).then(res => {
        if (res.code !== 0) { this.$message.error(res.message || '查询失败'); return }
        const list = res.result.list || []
        const headers = ['序号', '短信通道', '短信类型', '用户ID', '手机号码', '验证码', '短信内容', '发送状态', '校验状态', '报错原因', '发送时间', '回执时间']
        const rows = list.map((l, i) => [
          i + 1, this.providerName(l.provider), this.sceneLabel(l.scene), l.customerNo || '--', l.mobile,
          l.code || '--', l.content, this.sendStatusLabel(l.sendStatus), this.verifyStatusLabel(l.verifyStatus),
          l.errorMsg || '', this.fmtDateTime(l.sentAt), this.fmtDateTime(l.receiptAt)
        ])
        this.exportToCSV('短信发送记录', headers, rows)
        this.$message.success('导出成功，共 ' + list.length + ' 条记录')
      })
    },

    // ========== 规则 ==========
    fetchRules() {
      smsRuleList({ pageNum: 1, pageSize: 50 }).then(res => {
        if (res.code === 0) {
          this.rList = res.result.list || []
          const form = {}
          this.rList.forEach(r => {
            form[r.id] = {
              isDelete: r.isDelete, sendInterval: r.sendInterval, dailyLimit: r.dailyLimit,
              dailyResetMode: r.dailyResetMode, codeLength: r.codeLength,
              expireMinutes: r.expireMinutes, failLimit: r.failLimit,
              captchaEnabled: r.captchaEnabled == null ? 2 : r.captchaEnabled
            }
          })
          this.rForm = form
        } else this.$message.error(res.message || '查询失败')
      })
    },
    resetRule(rule) {
      this.rForm[rule.id] = {
        isDelete: rule.isDelete, sendInterval: rule.sendInterval, dailyLimit: rule.dailyLimit,
        dailyResetMode: rule.dailyResetMode, codeLength: rule.codeLength,
        expireMinutes: rule.expireMinutes, failLimit: rule.failLimit,
        captchaEnabled: rule.captchaEnabled == null ? 2 : rule.captchaEnabled
      }
    },
    collectChanges(rule) {
      const f = this.rForm[rule.id]
      const changes = []
      for (const key of ['sendInterval', 'dailyLimit', 'codeLength', 'expireMinutes', 'failLimit']) {
        const val = Number(f[key])
        if (isNaN(val) || val < 1) { this.$message.warning(RULE_LABEL[key] + ' 必须为不小于 1 的有效数值'); return null }
        if (val !== rule[key]) {
          const dir = RULE_LOOSEN[key] === 'up' ? (val > rule[key] ? 2 : 1) : (val > rule[key] ? 1 : 2)
          changes.push({ label: RULE_LABEL[key], old: rule[key], val, dir })
        }
      }
      const resetMode = Number(f.dailyResetMode)
      if (resetMode !== rule.dailyResetMode) {
        changes.push({
          label: '每日上限统计口径',
          old: rule.dailyResetMode === 1 ? '自然日0点重置' : '滚动24小时',
          val: resetMode === 1 ? '自然日0点重置' : '滚动24小时', dir: 3
        })
      }
      const status = Number(f.isDelete)
      if (status !== rule.isDelete) {
        changes.push({ label: '规则状态', old: rule.isDelete === 1 ? '启用' : '禁用', val: status === 1 ? '启用' : '禁用', dir: 3 })
      }
      const captcha = Number(f.captchaEnabled)
      const oldCaptcha = rule.captchaEnabled == null ? 2 : Number(rule.captchaEnabled)
      if (captcha !== oldCaptcha) {
        // 开启图形验证码=收紧(1), 关闭=放宽(2), 与后端 changeType 保持一致
        changes.push({ label: '开启图形验证码', old: this.captchaLabel(oldCaptcha), val: this.captchaLabel(captcha), dir: captcha === 1 ? 1 : 2 })
      }
      return changes
    },
    saveRule(rule) {
      const changes = this.collectChanges(rule)
      if (!changes) return
      if (!changes.length) { this.$message.warning('未检测到任何变更'); return }
      const hasLoosen = changes.some(c => c.dir === 2)
      if (rule.verifyType === 'FINANCE_PWD' && hasLoosen) {
        this.rulePending = { rule, changes }
        this.ruleConfirmChanges = changes.filter(c => c.dir === 2)
        this.ruleConfirmText = ''
        this.ruleConfirmVisible = true
        return
      }
      this.applyRuleSave(rule, '')
    },
    saveRuleStatus(rule) {
      const changes = this.collectChanges(rule)
      if (!changes) return
      this.applyRuleSave(rule, '')
    },
    confirmRuleSave() {
      if (!this.ruleConfirmText.trim()) { this.$message.error('请填写变更原因后再保存'); return }
      this.applyRuleSave(this.rulePending.rule, this.ruleConfirmText.trim())
      this.ruleConfirmVisible = false
    },
    applyRuleSave(rule, reason) {
      const f = this.rForm[rule.id]
      const dto = {
        id: rule.id, verifyType: rule.verifyType,
        sendInterval: Number(f.sendInterval), dailyLimit: Number(f.dailyLimit),
        codeLength: Number(f.codeLength), expireMinutes: Number(f.expireMinutes),
        failLimit: Number(f.failLimit), dailyResetMode: Number(f.dailyResetMode),
        captchaEnabled: Number(f.captchaEnabled),
        isDelete: Number(f.isDelete), operator: this.getOperator(), confirmReason: reason
      }
      smsRuleAddOrUpdate(dto).then(res => {
        if (res.code === 0) {
          this.$message.success(reason ? '规则已保存并记录放宽原因' : '规则保存成功，即刻生效')
          this.fetchRules()
          this.fetchRuleLogs()
        } else this.$message.error(res.message || '操作失败')
      })
    },
    fetchRuleLogs() {
      this.rLogLoading = true
      const data = { pageNum: this.rLogPageNum, pageSize: this.rLogPageSize }
      Object.keys(this.rLogSearch).forEach(k => {
        if (this.rLogSearch[k] !== '' && this.rLogSearch[k] !== null && this.rLogSearch[k] !== undefined) data[k] = this.rLogSearch[k]
      })
      if (this.rLogDateRange && this.rLogDateRange.length === 2) {
        data.startDate = this.rLogDateRange[0]
        data.endDate = this.rLogDateRange[1]
      }
      smsRuleLogList(data).then(res => {
        if (res.code === 0) { this.rLogTable = res.result.list || []; this.rLogTotal = res.result.total || 0 }
        else this.$message.error(res.message || '查询失败')
      }).finally(() => { this.rLogLoading = false })
    },
    resetRuleLogSearch() {
      this.rLogSearch = { verifyType: '', operator: '', startDate: '', endDate: '' }
      this.rLogDateRange = null
      this.rLogPageNum = 1; this.fetchRuleLogs()
    },

    // ========== 工具 ==========
    providerName(t) { return PROVIDER[t] || '--' },
    sceneLabel(s) { return SCENE[s] || s || '--' },
    ruleTypeLabel(t) { return RULE_SCENE[t] || t || '--' },
    ruleIcon(t) { return { REGISTER: '📝', LOGIN: '🔑', RESET_PWD: '🔒', FINANCE_PWD: '💰' }[t] || '📲' },
    langLabel(l) { return LANG[l] || l || '--' },
    sendStatusLabel(s) { return (SEND_STATUS[s] && SEND_STATUS[s].label) || '--' },
    sendStatusTag(s) { return (SEND_STATUS[s] && SEND_STATUS[s].tag) || 'info' },
    verifyStatusLabel(s) { return (VERIFY_STATUS[s] && VERIFY_STATUS[s].label) || '--' },
    verifyStatusTag(s) { return (VERIFY_STATUS[s] && VERIFY_STATUS[s].tag) || 'info' },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '--' },
    captchaLabel(v) { return Number(v) === 1 ? '是' : '否' },
    exportToCSV(filename, headers, rows) {
      const esc = c => {
        const s = String(c == null ? '' : c)
        return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
      }
      const csv = [headers.join(','), ...rows.map(r => r.map(esc).join(','))].join('\n')
      const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename + '.csv'
      link.click()
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.table-wrapper { background: #fff; border-radius: 10px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.filter-bar { margin-top: 4px; }
.table-header { display: flex; align-items: center; justify-content: space-between; margin: 12px 0; }
.table-title { font-size: 15px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; align-items: center; }
.badge { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 12px; color: var(--brand-primary); background: var(--brand-primary-a12); }
.form-section-title { font-size: 14px; font-weight: 600; color: #1a2236; margin: 8px 0 12px; padding-bottom: 8px; border-bottom: 1px solid var(--brand-primary); }
.form-grid { display: grid; grid-template-columns: 1fr 1fr; column-gap: 20px; }
.form-hint { font-size: 12px; color: #9ca3af; margin-top: 4px; line-height: 1.6; }
.detail-body { padding: 0 4px; }
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 16px; font-size: 13px; }
.detail-label { color: #9ca3af; }
.detail-section-title { font-size: 14px; font-weight: 600; color: #1a2236; margin: 16px 0 8px; padding-bottom: 8px; border-bottom: 1px solid #e8ecf2; }
.detail-content { padding: 10px 12px; background: #f5f6fa; border-radius: 6px; font-size: 13px; font-family: ui-monospace, monospace; }
.test-tpl { font-size: 13px; margin-bottom: 12px; color: #4e5969; }
.rule-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)); gap: 16px; margin: 4px 0 24px; }
.rule-card { border: 1px solid #e5e6eb; border-radius: 10px; padding: 16px; box-shadow: 0 1px 4px rgba(0,0,0,0.04); }
.rule-head { display: flex; align-items: center; gap: 8px; margin-bottom: 14px; padding-bottom: 12px; border-bottom: 1px solid #eee; }
.rule-icon { width: 32px; height: 32px; border-radius: 8px; background: #e8f3ff; display: flex; align-items: center; justify-content: center; font-size: 16px; }
.rule-title { font-size: 15px; font-weight: 600; color: #1b1b1f; }
.rule-code { font-size: 12px; color: #86909c; font-family: ui-monospace, monospace; }
.rule-status { margin-left: auto; }
.rule-body { display: flex; flex-direction: column; gap: 6px; }
.rule-item { display: flex; align-items: center; justify-content: space-between; font-size: 13px; color: #4e5969; }
.rule-label { flex: none; }
.rule-foot { display: flex; align-items: center; justify-content: space-between; margin-top: 14px; padding-top: 12px; border-top: 1px solid #eee; }
.rule-meta { font-size: 12px; color: #86909c; }
.rule-btns { display: flex; gap: 8px; }
.confirm-warn { font-size: 13px; color: #4e5969; line-height: 1.7; margin-bottom: 12px; }
.confirm-changes { font-size: 13px; line-height: 1.9; color: #4e5969; padding: 10px; background: #fff7f7; border: 1px solid #ffd6d6; border-radius: 6px; margin-bottom: 12px; }
</style>
